import { useState } from "react";

import { Checkbox } from "@newsela/angelou";

import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";

import { ContentLevel } from "@/types/models/ContentLevel.interface";

import useTranslatorControlsContext from "@/view/utils/useTranslatorControlsContext";
import { checkBoxLabelCss } from "./TranslationSetting.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

interface TranslationSettingProps {
  assignmentId: string;
  currentContentLevel: Pick<ContentLevel, "header_id" | "id">;
  isTranslationHidden: boolean;
  onHideTranslation: (arg: boolean) => void;
}

export const TranslationSetting = ({
  assignmentId,
  currentContentLevel,
  isTranslationHidden,
  onHideTranslation,
}: TranslationSettingProps) => {
  const [isTranslationVisibleChecked, setIsTranslationVisibleChecked] =
    useState(!isTranslationHidden);
  const { setIsTranslateMode } = useTranslatorControlsContext();

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.update,
    streamProperties: {
      content_type: "Article",
      content_id: currentContentLevel?.id,
      content_ids: [currentContentLevel?.header_id],
      description: `Toggle students can translate each paragraph using AI ${isTranslationHidden ? "off" : "on"}`,
      object_id: assignmentId,
    },
  };

  return (
    <CheckboxWithTrackEvent
      __cssFor={{ root: checkBoxLabelCss(isTranslationVisibleChecked) }}
      checked={isTranslationVisibleChecked}
      label="Students can translate each paragraph using AI"
      name="Students can translate each paragraph using AI"
      dataProps={{
        "data-qa-selector": `students_can_translate_each_paragraph_using_AI_${isTranslationHidden ? "off" : "on"}`,
      }}
      onClick={() => {
        setIsTranslationVisibleChecked(
          (prevIsTranslationVisibleChecked) => !prevIsTranslationVisibleChecked,
        );
        !isTranslationHidden && setIsTranslateMode(false);
        onHideTranslation(!isTranslationHidden);
      }}
      {...eventProperties}
    />
  );
};

export default TranslationSetting;
